import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '@/views/pc/Home'),
    meta: {
      title: '精创校准服务'
    }
  },
  {
    path: '/mobile',
    name: 'Mobile',
    component: () => import(/* webpackChunkName: "Home" */ '@/views/Mobile'),
    meta: {
      title: '精创校准服务'
    }
  },
  {
    path: '/notice',
    name: 'Notice',
    component: () => import(/* webpackChunkName: "Notice" */ '@/views/pc/Notice'),
    meta: {
      title: '精创校准服务'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  // base: '/elitech-calibration-web',
  routes
})

router.beforeEach((to, from, next) => {
  console.log(to, from, next)
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    console.log('手机端')
    // 手机端
    if (to.name === 'Home') {
      next({ path: '/mobile' })
    } else {
      next()
    }
  } else {
    console.log('PC端')
    // PC端
    if (to.name === 'Mobile') {
      next({ path: '/' })
    } else {
      next()
    }
  }
})

export default router
